module.exports = __webpack_public_path__ + "media/images/video-play-288308b2.png";